import type { FormLabelProps as CoreFormLabelProps } from "@mui/material/FormLabel";
import CoreFormLabel from "@mui/material/FormLabel";
import type { ReactNode } from "react";

export type FormLabelProps = CoreFormLabelProps;
export const FormLabel: (props: FormLabelProps) => ReactNode = CoreFormLabel;
